import { useAtomValue } from "jotai";
import type { FunctionComponent } from "react";

import type { BlurbCardHighlightSection } from "scmp-app/components/plus/atoms";
import { usePlusBlurbPopup } from "scmp-app/components/plus/blurb-popup/hooks";
import { rosettaAtom } from "scmp-app/lib/rosetta";

import { Container, PlusBlurbOverlay } from "./styles";
type Props = {
  children: React.ReactNode;
  section: BlurbCardHighlightSection;
};

export const PlusBlurbPopupChecker: FunctionComponent<Props> = ({ children, section }) => {
  const { handleOpen: handleOpenBlurbPopup, hasScmpPlusAccessRight } = usePlusBlurbPopup();
  const asyncRosettaState = useAtomValue(rosettaAtom);
  const isRosettaDataReady = asyncRosettaState?.result?.hasPianoExperienceExecuted ?? false;
  return (
    <Container>
      {isRosettaDataReady && !hasScmpPlusAccessRight && (
        <PlusBlurbOverlay onClick={() => handleOpenBlurbPopup(section)} />
      )}
      {children}
    </Container>
  );
};

PlusBlurbPopupChecker.displayName = "PlusBlurbPopupChecker";
